<p class="client-requirement">{{ 'documentSummary.clientRequired' | translate }}</p>

<section class="document-summary-selects">
  <app-client-search
    [preselected]="selectedClient"
    (clientSelected)="onClientSelected($event)"
  ></app-client-search>

<mat-form-field appearance="outline">
  @if (areWorkProcessesLoading) {
    <mat-icon matPrefix class="loading">hourglass_top</mat-icon>
  }
  <mat-label>{{ 'documentSummary.selectWorkProcess' | translate }}</mat-label>
  <mat-select
    [(value)]="selectedWorkProcess"
    [disabled]="!selectedClient || areWorkProcessesLoading || workProcessesError"
    (selectionChange)="onWorkProcessChange()"
  >
    @if (preselectedWorkProcess) {
      <mat-option [value]="null">
        {{ 'documentSummary.noWorkProcessOption' | translate }}
      </mat-option>
    }
    @for (process of workProcesses; track process.werkprocesNummer) {
      <mat-option [value]="process.werkprocesNummer">
        {{ formatWorkProcessLabel(process) }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
</section>

@if (workProcessesNotFound) {
  <app-inline-snackbar
    [type]="SnackbarType.INFO"
    [message]="'documentSummary.workProcessesNotFound' | translate"
    [showCloseButton]="false"
  ></app-inline-snackbar>
}

@if (workProcessesError) {
  <app-inline-snackbar
    [type]="SnackbarType.INFO"
    [message]="'documentSummary.workProcessesError' | translate"
    [showCloseButton]="false"
  ></app-inline-snackbar>
}

<section class="document-summary-option">
  <p>{{ 'documentSummary.current' | translate }}</p>
<button
  mat-stroked-button
  [disabled]="!selectedClient || isGenerating || areWorkProcessesLoading"
  [class.disabled]="!selectedClient || isGenerating || areWorkProcessesLoading"
  (click)="generateSummary()"
>
  @if (isGenerating) {
    <ng-container>
      <mat-icon class="loading">hourglass_top</mat-icon>
      {{ 'documentSummary.generating' | translate }}
    </ng-container>
  } @else {
    {{ 'button.generate' | translate }}
  }
</button>
</section>

@if (summaryFile || isGenerating) {
  <section class="document-summary-review">
    <p>{{ 'documentSummary.checkDescription' | translate }}</p>

    <button mat-stroked-button (click)="previewSummary()">
      {{ 'documentEditor.preview' | translate }}
    </button>
  </section>
}

@if (downloadError) {
  <app-inline-snackbar
    [type]="
      downloadErrorType === 'danger'
        ? SnackbarType.ERROR
        : downloadErrorType === 'warning'
          ? SnackbarType.WARNING
          : SnackbarType.INFO
    "
    [message]="downloadError | translate"
    [showCloseButton]="false"
    (closeSnackbar)="downloadError = null"
  ></app-inline-snackbar>
}
